import { useState, useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchCompanyList = async (params) => {
  const response = await get("/admin/common/companyModalList", { params });
  return response.result;
};

export function useCompanyLogic() {
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
    },
    shouldFocusError: false, // Focus 방지
  });

  const { handleSubmit, watch } = methods;

  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 10;

  const { searchCnd, searchWrd } = committedSearch;


  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["selectCompanyModalList", committedSearch, pageIndex],
    queryFn: () =>
      fetchCompanyList({ searchCnd, searchWrd, pageIndex, recordCountPerPage, }),
      keepPreviousData: true,
      staleTime: 600000,
  });

  useEffect(() => {
    refetch();
  }, [pageIndex, refetch]);

  const onSubmit = (values) => {
    setCommittedSearch({
      searchCnd: values.searchCnd,
      searchWrd: values.searchWrd,
    });
    setPageIndex(1);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  return {
    methods,
    handleSubmit,
    watch,
    data,
    isLoading,
    isError,
    error,
    onSubmit,
    handlePageChange,
    pageIndex,
    recordCountPerPage,
  };
}
